import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PaymentModesService as PaymentModeServiceV2 } from '@checkout-v2/feature';
import { PaymentModeService } from '@checkout/feature';
import { CookieKeys } from '@core/const';
import { CookieService } from '@core/feature';
import { Payment } from '@payment/const';
import { PaymentService } from '@payment/feature';
import { SdvorSpinnerComponent } from '@sdvor/shared/ui';
import { UserIdService } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SdvorPaymentsModule } from './payments.module';
import { SdvorRemovePaymentModalComponent } from './remove-payment-modal/remove-payment-modal.component';

@Component({
  selector: 'sd-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorSpinnerComponent, SdvorPaymentsModule, NgIf, AsyncPipe],
})
export class PaymentsComponent implements OnInit {
  payments$: Observable<Payment[]>;
  hasPayments$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  isError$: Observable<boolean>;
  isEmulatedUser$: Observable<boolean>;
  isCheckoutV2Enabled = this.cookieService.hasKey(CookieKeys.ChekoutV2Enabled);

  constructor(
    private modalService: ModalService,
    private paymentService: PaymentService,
    private paymentModeService: PaymentModeService,
    private paymentModeServiceV2: PaymentModeServiceV2,
    private userIdService: UserIdService,
    private cookieService: CookieService,
  ) {}

  ngOnInit(): void {
    this.payments$ = this.paymentService.getPayments();
    this.hasPayments$ = this.payments$.pipe(map((payments: Payment[]) => !!payments.length));
    this.isLoading$ = this.paymentService.getPaymentsLoading().pipe(startWith(true));
    this.isError$ = this.paymentService.getPaymentsError();
    this.isEmulatedUser$ = this.userIdService.isEmulated();
  }

  addPayment(): void {
    if (this.isCheckoutV2Enabled) {
      this.paymentModeServiceV2.initCardBindingOnExternalAddress();
    } else {
      this.paymentModeService.initCardBindingOnExternalAddress();
    }
  }

  removePayment(payment: Payment): void {
    const modal = this.modalService.open(SdvorRemovePaymentModalComponent, { size: 'xs', centered: true });
    modal.result
      .catch(() => false)
      .then((value: string | boolean) => {
        if (value === true) {
          this.paymentService.deletePayment(payment);
        }
      });
  }
}
